export function LoadingScreen() {
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-background z-50">
            <div className="flex flex-col items-center gap-6 relative">
                {/* Pulsing background ring */}
                <div className="absolute inset-0 -m-8 border-4 border-primary/20 animate-ping rounded-full" style={{ animationDuration: '2s' }} />

                {/* Main loader */}
                <div className="w-16 h-16 sm:w-20 sm:h-20 neo-border loader-box neo-shadow-lg relative z-10" />

                {/* Brand */}
                <div className="flex flex-col items-center gap-3 relative z-10">
                    <h2 className="text-2xl sm:text-3xl font-black tracking-[0.15em] text-foreground uppercase">
                        AadishLabs
                    </h2>
                    <div className="flex gap-1.5">
                        <span className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
                        <span className="w-2 h-2 bg-secondary rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
                        <span className="w-2 h-2 bg-accent rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
                    </div>
                    <p className="text-xs font-bold uppercase tracking-widest text-muted-foreground">Loading your experience</p>
                </div>
            </div>
        </div>
    );
}
